import { diarySharingConstants } from '../_constants/diarySharing.constants';
import { diarySharingService } from '../_services/diarySharing.service';

export const diarySharingActions = {
    fetchSettings,
    toggleBulkShare,
    updateStaffVisibility,
    fetchMyVisibility,
};

function fetchSettings() {
    return async (dispatch) => {
        dispatch({ type: diarySharingConstants.FETCH_REQUEST });
        try {
            const data = await diarySharingService.fetchSettings();
            dispatch({
                type: diarySharingConstants.FETCH_SUCCESS,
                bulkShare: data.bulkShare,
                staff: data.staff,
            });
        } catch (err) {
            dispatch({
                type: diarySharingConstants.FETCH_FAILURE,
                error: err?.message || 'Failed to load sharing settings',
            });
        }
    };
}

function toggleBulkShare(shareAll) {
    return async (dispatch) => {
        dispatch({ type: diarySharingConstants.UPDATE_BULK, bulkShare: shareAll });
        try {
            await diarySharingService.toggleBulkShare(shareAll);
        } catch {
            dispatch(fetchSettings());
        }
    };
}

function updateStaffVisibility(staffId, { diaryVisibility, diaryVisibleTo }) {
    return async (dispatch) => {
        dispatch({
            type: diarySharingConstants.UPDATE_STAFF,
            staffId,
            diaryVisibility,
            diaryVisibleTo: diaryVisibleTo || [],
        });
        try {
            await diarySharingService.updateStaffVisibility(staffId, {
                diaryVisibility,
                diaryVisibleTo,
            });
        } catch {
            dispatch(fetchSettings());
        }
    };
}

function fetchMyVisibility() {
    return async (dispatch) => {
        try {
            const { canSee } = await diarySharingService.fetchMyVisibility();
            dispatch({ type: diarySharingConstants.VISIBILITY_LOAD, canSee });
        } catch {
            // silent
        }
    };
}
